import styled from "styled-components";

export const WarningText = styled.div`
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: ${({ theme }) => theme.red};
`;
